import React, { useState } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const SIG = [["OFF", "Desligada"], ["MONITOR", "Monitorar (transição)"], ["ENFORCE", "Exigir"]];

export const SignaturePanel = ({ readiness, onSigMode, reload }) => {
  const [secrets, setSecrets] = useState({});
  const save = async (account) => {
    try {
      await api.put("/admin/payment-center/webhook-secret", { account, secret: secrets[account] || "" });
      setSecrets((s) => ({ ...s, [account]: "" }));
      toast.success("Assinatura secreta salva (criptografada)");
      reload();
    } catch (e) { toast.error(e?.response?.data?.detail || "Falha ao salvar"); }
  };
  return (
    <section className="border border-[#EBE5DF] bg-white p-6" data-testid="pc-signature-section">
      <h2 className="text-lg font-semibold mb-1">Segurança dos webhooks (x-signature)</h2>
      <p className="text-xs text-[#5C5A57] mb-4">
        Todo pagamento é consultado no Mercado Pago antes da baixa. MONITORAR registra falhas sem bloquear e é só uma etapa de transição: não libera a Central.
      </p>
      <div className="flex gap-2 mb-5">
        {SIG.map(([k, l]) => (
          <button key={k} onClick={() => onSigMode(k)} disabled={readiness.signature_mode === k} data-testid={`pc-sig-${k}`}
            className={`px-3 py-2 text-sm border ${readiness.signature_mode === k ? "border-[#1A1A1A] bg-[#1A1A1A] text-white" : "border-[#EBE5DF] hover:border-[#1A1A1A]"}`}>{l}</button>
        ))}
      </div>
      <ul className="space-y-3" data-testid="pc-accounts-list">
        {readiness.accounts.length === 0 && <li className="text-sm text-[#5C5A57]">Nenhuma conta recebedora configurada.</li>}
        {readiness.accounts.map((a) => (
          <li key={a.account} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`pc-account-${a.account}`}>
            <KeyRound size={14} />
            <span className="min-w-[220px]">{a.label}</span>
            <span className={a.has_secret ? "text-[#067647]" : "text-[#B42318]"} data-testid={`pc-account-status-${a.account}`}>
              {a.has_secret ? `Assinatura cadastrada ${a.masked || ""}` : "Sem assinatura secreta"}
            </span>
            <input type="password" autoComplete="new-password" value={secrets[a.account] || ""} placeholder="Nova assinatura secreta"
              onChange={(e) => setSecrets((s) => ({ ...s, [a.account]: e.target.value }))}
              className="border border-[#EBE5DF] p-1.5 text-sm flex-1 min-w-[200px]" data-testid={`pc-secret-input-${a.account}`} />
            <button className="ghost" onClick={() => save(a.account)} data-testid={`pc-secret-save-${a.account}`}>Salvar</button>
          </li>
        ))}
      </ul>
    </section>
  );
};
